<template>
  <el-space direction="vertical" fill style="width: 100%;">
    <el-card>
    <div>
      <el-row>
        <el-col :span="2">
          <el-tag>只展示厂商</el-tag>
        </el-col>
        <el-col :span="2">
          <el-tag>只显示中国</el-tag>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-form
        :model="listQuery"
        ref="loginForm"
        label-width="0px"
        :rules="rules"
        style="padding-top: 0px"
      >
        <el-row>
          <el-col :span="2">
            <el-switch
              v-model="switchStatus"
              active-color="#13ce66"
              @change="switchChange"
            />
          </el-col>
          <el-col :span="2">
            <el-switch
              v-model="showCountry"
              active-color="#13ce66"
              @change="showCountryHandle"
            />
          </el-col>
          <el-col :span="4" :offset="2">
            <el-form-item prop="name">
              <el-input
                v-model="listQuery.name"
                placeholder="厂商名"
                style="width: 300px"
                @keydown.enter="searchList"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="2" v-if="!switchStatus">
            <el-form-item prop="developer">
              <el-input
                v-model="listQuery.developer"
                placeholder="开发商账号"
                style="width: 300px"
                @keydown.enter="searchList"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-form-item>
              <el-button @click="searchList">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>

  <el-card :body-style="{ padding: '2px' }">
    <div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :key="key2"
          @cell-click="rowClick"
          v-loading="loading"
        >
          <el-table-column prop="id" label="厂商ID" width="120" />
          <el-table-column prop="name" label="厂商">
            <template v-slot="{ row }" v-if="inputStatus && !switchStatus">
              <el-input
                v-model="row.name"
                class="input-text"
                @blur="modifyManufacturer(row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="developer"
            label="开发商"
            width="400"
            v-if="!switchStatus"
          />
          <el-table-column prop="country" label="国家" width="400" />
          <el-table-column label="Operate" width="200" v-if="!switchStatus">
            <template v-slot="{ row }">
              <el-button @click="showDialog(row)">更改厂商</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
  <div class="fixed-pagination">
    <el-pagination
      v-model:currentPage="listQuery.page"
      :page-sizes="[10, 20, 50, 100]"
      v-model:page-size="listQuery.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalRecord"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
    >
    </el-pagination>
  </div>
  <el-dialog v-model="dialogShow">
    <el-form v-model="formData" :label-width="85" label-position="left">
      <el-row justify="center"
        ><span style="color: red; margin-bottom: 20px; font-size: 18px"
          >修改厂商名，同时会修改该开发商账号下所有游戏的厂商信息，谨慎修改！</span
        ></el-row
      >
      <el-row justify="center">
        <el-form-item prop="id" label="厂商ID">
          <el-input v-model="formData.id" disabled />
        </el-form-item>
      </el-row>
      <el-row justify="center">
        <el-form-item prop="name" label="厂商名">
          <el-input v-model="formData.name" />
        </el-form-item>
      </el-row>
      <el-row justify="center">
        <el-form-item prop="developer" label="开发商账号">
          <el-input v-model="formData.developer" disabled style="width: 150%" />
        </el-form-item>
      </el-row>
      <el-row justify="center">
        <el-form-item prop="country" label="国家">
          <el-input v-model="formData.country" style="width: 150%" />
        </el-form-item>
      </el-row>
      <el-row justify="center">
        <el-form-item label-width="0">
          <el-button @click="modifyManufacturerDeveloper">提交</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
  </el-space>
</template>

<script>
import {
  updateManufacturer,
  getManufacturerDeveloper,
  getManufacturerSimpleList,
} from "../api/app";
import { checkPermission } from "../utils/auth";
import { messageWarning } from "../utils/message";
import enumValue from "../utils/enum";
import { deepCopy } from "../utils/util";
const defaultPage = 1;
const defaultSize = 100;
const defaultListQuery = {
  id: undefined,
  name: "",
  developer: "",
  country: "",
  page: defaultPage,
  pageSize: defaultSize,
};
export default {
  data() {
    return {
      loading: false,
      dialogShow: false,
      totalRecord: undefined,
      switchStatus: false,
      showCountry: false,
      switchValue: true,
      key2: "",
      listQuery: deepCopy(defaultListQuery),
      tableData1: [],
      tableData2: [],
      formData: {},
      inputStatus: checkPermission(enumValue.permissionAdmin),
    };
  },
  created() {
    const listQuery = this.$route.query.listQuery;
    const switchStatus = this.$route.query.switchStatus;
    if (listQuery) {
      this.listQuery = JSON.parse(listQuery);
      if (this.listQuery.country != "") {
        this.showCountry = true;
      }
    }
    console.log(switchStatus, listQuery);
    if (switchStatus == undefined && listQuery == undefined) {
      return;
    } else if (switchStatus == "true") {
      this.switchStatus = true;
      this.getSimpleList();
      return;
    } else if (switchStatus == "false") {
      this.switchStatus = false;
    }
    this.getList();
  },
  watch: {
    $route(to, from) {
      //监听相同路由下参数变化的时候，从而实现异步刷新
      //重新获取数据
      if (to.name == from.name) {
        const listQuery = this.$route.query.listQuery;
        const switchStatus = this.$route.query.switchStatus;
        if (listQuery) {
          this.listQuery = JSON.parse(listQuery);
        } else {
          this.listQuery = defaultListQuery;
        }
        if (this.listQuery.country != "") {
          this.showCountry = true;
        } else {
          this.showCountry = false;
        }
        if (switchStatus == "true") {
          this.switchStatus = true;
          this.getSimpleList();
          return;
        } else if (switchStatus == "false") {
          this.switchStatus = false;
        }
        this.getList();
      }
    },
  },
  methods: {
    // 获取厂商开发商列表
    getList() {
      this.loading = true;
      getManufacturerDeveloper(this.listQuery)
        .then((resp) => {
          this.tableData = resp.data.data.records;
          this.totalRecord = resp.data.data.total;
          this.key2 = Math.random();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // 获取厂商列表
    getSimpleList() {
      this.loading = true;
      getManufacturerSimpleList(this.listQuery)
        .then((resp) => {
          this.tableData = resp.data.data.records;
          this.totalRecord = resp.data.data.total;
          this.key2 = Math.random();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // 进入厂商账号列表
    rowClick(row, column) {
      if (
        (column.property != "name" && column.label != "Operate") ||
        this.switchStatus == true ||
        (column.property == "name" && (!this.inputStatus || this.switchStatus))
      ) {
        if (this.switchStatus) {
          let params = deepCopy(this.listQuery);
          params.name = row.name;
          params.page = defaultPage;
          params.pageSize = defaultSize;
          let routeUrl = this.$router.resolve({
            name: "developerList",
            query: {
              listQuery: JSON.stringify(params),
              switchStatus: false,
            },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          var searchDeveloper = "";
          if (column.property == "developer") {
            searchDeveloper = row.developer;
          }
          let routeUrl = this.$router.resolve({
            name: "manufacturerAppList",
            query: {
              name: row.name,
              developer: row.developer,
              searchDeveloper: searchDeveloper,
            },
          });
          window.open(routeUrl.href, "_blank");
        }
      }
    },
    // 修改厂商名称
    modifyManufacturer(row) {
      if (!checkPermission(enumValue.permissionAdmin)) {
        messageWarning("权限不足！！！");
        return;
      }
      updateManufacturer({
        id: row.id,
        name: row.name,
        developer: row.developer,
      }).then(() => {
        this.getList();
      });
    },
    // 页面条数变化
    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.$router.push({
        name: "developerList",
        query: {
          listQuery: JSON.stringify(this.listQuery),
          switchStatus: this.switchStatus,
        },
      });
    },
    // 翻页
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.$router.push({
        name: "developerList",
        query: {
          listQuery: JSON.stringify(this.listQuery),
          switchStatus: this.switchStatus,
        },
      });
    },
    // 显示dialog
    showDialog(row) {
      if (!checkPermission(enumValue.permissionAdmin)) {
        messageWarning("权限不足！！！");
        return;
      }
      this.dialogShow = true;
      this.formData = row;
    },
    // 修改厂商名2
    modifyManufacturerDeveloper() {
      if (!checkPermission(enumValue.permissionAdmin)) {
        messageWarning("权限不足！！！");
        return;
      }
      this.formData.updateDeveloper = true;
      updateManufacturer(this.formData).then(() => {
        this.dialogShow = false;
        this.getList();
      });
    },
    searchList() {
      this.listQuery.page = defaultPage;
      this.$router.push({
        name: "developerList",
        query: {
          listQuery: JSON.stringify(this.listQuery),
          switchStatus: this.switchStatus,
          key: Math.random(),
        },
      });
    },
    // 开关状态切换
    switchChange() {
      this.listQuery.page = defaultPage;
      this.listQuery.pageSize = defaultSize;
      this.listQuery.name = "";
      this.listQuery.developer = "";
      this.$router.push({
        name: "developerList",
        query: {
          listQuery: JSON.stringify(this.listQuery),
          switchStatus: this.switchStatus,
        },
      });
    },
    // 国家切换
    showCountryHandle() {
      if (this.showCountry == true) {
        this.listQuery.country = "CN";
      } else {
        this.listQuery.country = "";
      }
      this.$router.push({
        name: "developerList",
        query: {
          switchStatus: this.switchStatus,
          listQuery: JSON.stringify(this.listQuery),
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
// 变量定义
$card-margin: 4px;
$card-side-margin: 5px;
$border-radius: 4px;
$input-bg-color: #fff;

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.input-text {
  & :deep(.el-input__inner) {
    -webkit-appearance: none;
    background-color: $input-bg-color;
    background-image: none;
    border-radius: $border-radius;
    border: 0;
    width: 100%;
    
    // 鼠标悬停效果
    &:hover {
      border-color: #dcdfe6;
    }
  }
}

.el-card {
  margin: $card-margin;
  margin-left: $card-side-margin;
  margin-right: $card-side-margin;
  
  // 卡片头部样式
  &__header {
    padding-bottom: 10px;
  }
}

// 表格样式嵌套
.el-table {
  
  &-column {
    &:first-child {
      font-weight: bold;
    }
  }
}

.el-space{
  margin-bottom: 80px;
}
</style>
